var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophyWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M0-47.5H35v35H0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(0 47.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4380",
    "data-name": "Path 4380",
    d: "M-1.685-.987H3.841c1.017,0,1.842-.1,1.842.921V-1.908A1.842,1.842,0,0,0,3.841-3.75H-3.527c-1.842,0-3.3,1.957-2.763,4.605,0,0,1.65,8.635,1.766,9.172A3.966,3.966,0,0,0-.8,12.829h6.41c1.017,0,.076-1.746.076-2.763V8.224a1.842,1.842,0,0,1-1.842,1.842H.157A2.064,2.064,0,0,1-1.685,8.224C-1.839,7.341-3.143,1.47-3.143,1.47-3.451-.3-2.7-.987-1.685-.987",
    transform: "translate(7.211 -40.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4381",
    "data-name": "Path 4381",
    d: "M-2.9-.987H-8.43c-1.017,0-2.591-.1-2.591.921V-1.908c0-1.017,1.574-1.842,2.591-1.842h7.368C.78-3.75,2.239-1.793,1.7.855,1.7.855.2,9.531.07,10.066a3.913,3.913,0,0,1-3.684,2.763H-10.2c-1.018,0-.826-1.746-.826-2.763V8.224c0,1.017,1.574,1.842,2.591,1.842h3.684A2.064,2.064,0,0,0-2.9,8.224c.153-.882,1.459-6.754,1.459-6.754C-1.139-.3-1.887-.987-2.9-.987",
    transform: "translate(32.206 -40.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4382",
    "data-name": "Path 4382",
    d: "M-2.961-1.017c0-6.409-2.5,0-2.5,0s-2.763-6.409-2.763,0S-11.25,8.193-11.25,8.193H.071s-3.031-2.8-3.031-9.211",
    transform: "translate(22.956 -25.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M-7.237-2.088c0,6.24-6.236,16.756-10.132,16.756S-27.5,4.152-27.5-2.088c0-4.785.921-5.82,2.763-5.82,1.266,0,5.549-.025,7.368-.025l6.447,0c2.687,0,3.684.631,3.684,5.847",
    transform: "translate(34.868 -38.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M-5.922-.987c0,1.017.1,1.842-.921,1.842H-21.58C-22.6.855-22.5.03-22.5-.987v-.921A1.949,1.949,0,0,1-20.582-3.75H-7.764A1.881,1.881,0,0,1-5.922-1.908Z",
    transform: "translate(31.711 -15.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M-7.237-.535C-7.237.165-7.2.732-8.5.732h-17.73C-27.424.732-27.5.165-27.5-.535v-.23a1.266,1.266,0,0,1,1.266-1.266H-8.5A1.266,1.266,0,0,1-7.237-.765Z",
    transform: "translate(34.868 -14.153)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyWhite);
export default __webpack_public_path__ + "static/media/trophy-white.70428949c1e41ede70f3297c3613d0e1.svg";
export { ForwardRef as ReactComponent };